import { AuditOutlined } from '@ant-design/icons-vue';
import AuditLog from '@/views/audit/AuditLog.vue';

/**
 * 操作紀錄：單層選單（與系統營運同層、排在其上方）
 * 路徑維持 /platform/audit-log；舊 /audit/logs 由 platformLegacyRedirects 導向
 */
export const auditLogRoute = {
    path: '/platform/audit-log',
    component: AuditLog,
    name: 'AuditLog',
    meta: {
        title: '操作紀錄',
        icon: AuditOutlined
    }
};

/** @deprecated 已改單層 auditLogRoute；保留別名避免舊 import 壞掉 */
export const auditFolderRoute = auditLogRoute;
export const auditChildrenRoutes = [];
